export const getLangIdFromCode = (language) => {
  if (language === "hi") return 1;
  return 2; 
};